import isPermissionEnabled from "common/isPermissionEnabled"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import formatDateTime from "components/Shared/formatDateTime"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { getCouponUsageDetails } from "store/actions/promotionsAction"

const CouponUsageDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t(`Coupon Usage Details | Namq`)

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, couponUsageDetails } = useSelector(state => state.Promotions)

  const { userRole, accountType } = useSelector(state => state.Login)

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      14,
      "promotion_1",
      accountType
    )

    if (!isPermissionList) {
      navigate("/dashboard")
    }
  }, [userRole])

  useEffect(() => {
    const fetchCouponUsageDetails = () => {
      const payload = {
        id,
      }
      dispatch(getCouponUsageDetails(payload))
    }
    fetchCouponUsageDetails()
  }, [])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton /> {t("Coupon Usage Details")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {loading ? (
                    <ShimmerThumbnail height={650} rounded />
                  ) : Object.values(couponUsageDetails).length === 0 ? (
                    <p className="text-center my-2">
                      {t("No coupons usage details found")}
                    </p>
                  ) : (
                    <Table className="table-nowrap mb-0 capitalize_td">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Id")}</th>
                          <td>{couponUsageDetails._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("User")}</th>
                          <td>
                            {couponUsageDetails?.userId?.firstName}{" "}
                            {couponUsageDetails?.userId?.lastName}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Email")}</th>
                          <td>{couponUsageDetails?.userId?.email || "-"} </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Phone Number")}</th>
                          <td>{couponUsageDetails?.userId?.phoneNumber} </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Customer Status")}</th>
                          <td>
                            {couponUsageDetails?.userId?.status === 1 ? (
                              <Badge className="bg-success">
                                {t("Active")}
                              </Badge>
                            ) : (
                              <Badge className="bg-danger">
                                {t("Deactive")}
                              </Badge>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Branch Name")}</th>
                          <td>{couponUsageDetails?.branchId?.name} </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Coupon Name")}</th>
                          <td>
                            {language === "sa"
                              ? couponUsageDetails?.coupon?.nameAr
                              : couponUsageDetails?.coupon?.name}{" "}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Coupon Code")}</th>
                          <td>{couponUsageDetails?.coupon?.code} </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Coupon Status")}</th>
                          <td>
                            {couponUsageDetails?.coupon?.status === 1 ? (
                              <Badge className="bg-success">
                                {t("Active")}
                              </Badge>
                            ) : (
                              <Badge className="bg-danger">
                                {t("Deactive")}
                              </Badge>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Created At")}</th>
                          <td>
                            {formatDateTime(couponUsageDetails?.createdAt) ||
                              "-"}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default CouponUsageDetails
